import ScrollToProvider from './ScrollTo.provider';

export default ScrollToProvider;
